import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { detect } from 'detect-browser';
import { ConfigManagerPropertiesEnum } from '../../enums/config-manager-properties.enum';

@Component({
  selector: 'app-version-banner',
  templateUrl: './version-banner.component.html',
  styleUrls: ['./version-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VersionBannerComponent implements OnInit {
  browserInfo;

  constructor(private configManagerService: ConfigManagerService) {}

  ngOnInit(): void {
    this.browserInfo = detect();
  }

  get buildVersion(): string {
    return this.configManagerService.getSetting<string>(ConfigManagerPropertiesEnum.BuildVersion);
  }
}
